"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Add a custom color": "Agregar un color personalizado",
  Apply: "Aplicar",
  "Apply color": "Aplicar color",
  Automatic: "Automático",
  Cancel: "Cancelar",
  "Cancel color": "Cancelar color",
  Change: "Cambiar",
  Custom: "Personalizado",
  "Custom color picker": "Selector de colores personalizados",
  "Invalid hex value": "Valor hexadecimal no válido",
  Remove: "Quitar",
  "Select color {color}": ["Seleccionar color ", ["color"]],
  "You’ve reached the {maxCustomColors} custom colors limit. To add another color, remove one first.": ["Alcanzó el límite de colores personalizados ", ["maxCustomColors"], ". Para agregar otro color, primero elimine uno."]
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map